module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0011_10_C18_1.b8419b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0011_10_C18_1.jpg
// module id = SByP
// module chunks = 0